import { Component, Input, OnInit } from '@angular/core';
import { CommunicationService } from '../../../../services/communication.service';
import { PageService } from '../../../../services/page.service';
import { PageChangedEvent } from '../../../../utils/events/page-changed-event';
import { Note } from '../../../../models/note';
import { SidebarService } from '../../../../services/sidebar.service';
import { environment } from '../../../../../environments/environment';
import { Rect } from '../../../../models/rect';
import { RectService } from '../../../../services/rect.service';
import { TechnicalFeature } from '@lemberger/lemberger-am';
import { PageTextService } from '../../../../services/page-text.service';
import { TextSelection } from '../../../../models/text-selection';
import { BookFeatureActivationService } from '../../../../services/book-feature-activation.service';
import { SafeHtmlPipe } from '../../../../pipes/safe-html.pipe';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'sidebar-single-note',
    templateUrl: './sidebar-single-note.component.html',
    styleUrls: ['./sidebar-single-note.component.scss'],
    standalone: true,
    imports: [
        SafeHtmlPipe,
        DatePipe
    ]
})
export class SidebarSingleNoteComponent implements OnInit {

    @Input() note: Note;

    date: Date;
    pageText: string;
    time: string;
    realPageNumber: number;
    isRect: boolean;

    constructor(public bookFeatureActivationService: BookFeatureActivationService,
                private pageService: PageService,
                private sidebarService: SidebarService,
                private rectService: RectService,
                private textSelectionService: PageTextService,
                private communicationService: CommunicationService) {
    }

    ngOnInit(): void {

        this.realPageNumber = this.getRealPageNumber();
        this.date = this.getDate();
        this.time = this.getTime();
        this.pageText = this.getPageText();
        this.isRect = this.note instanceof Rect;
    }

    getRealPageNumber(): number {
        return this.pageService.getRealPageNumber(this.note.index);
    }

    goToPage(): void {
        const pageChangeEvent = new PageChangedEvent();
        pageChangeEvent.moveToPage = this.note.index;
        this.communicationService.announcePageTurn(pageChangeEvent);

        if (window.window.innerWidth <= (environment.mobileBreakPoint + 1)) {
            this.sidebarService.closeSidebar();
        }
    }

    getDate(): Date {
        // If date is available and presented as string (comes from backend)
        if (this.note.updatedAt && this.note.updatedAt.replace) {
            const date = new Date(this.note.updatedAt.replace(' ', 'T')
                .substr(0, 19));

            return date;

            // No valid date available
        }

        return new Date();
    }

    getTime(): string {
        const date = this.getDate();
        let minutes = date.getMinutes()
            .toString();
        let hour = date.getHours()
            .toString();

        if (hour.toString().length < 2) {
            hour = `0${hour}`;
        }

        if (minutes.toString().length < 2) {
            minutes = `0${minutes}`;
        }

        return `${hour}:${minutes}`;
    }

    getPageText(): string {

        const realPageNumber = this.getRealPageNumber();

        if (realPageNumber > 0) {

            return `Seite ${this.realPageNumber}`;

        } else if (this.note.index === 0) {

            return 'Cover';

        }

        return 'Ohne Seitenangabe';
    }

    getNoteColor(): string {

        if (!this.note.color) {
            return 'gold';
        }

        return this.note.color.getColorString();
    }

    delete(): void {

        if ((this.note as Rect).logType === TechnicalFeature.Notes) {

            const rect = this.note as Rect;
            rect.isDeleted = true;
            if (!rect.id) {
                this.note = undefined;
            }

            this.rectService.deleteRect(rect)
                .then(() => {
                    this.note = undefined;

                });
        } else {

            const textSelection = this.note as TextSelection;
            textSelection.isDeleted = true;

            if (textSelection.textBoxes) {
                textSelection.textBoxes.forEach(ele => {
                    ele.isHighlighted = false;
                });
            }

            this.textSelectionService.removeTextSelection(textSelection);
        }
    }
}
